var map = {
	"./combinatie_w300.png": 140,
	"./logo_looms.png": 4765,
	"./logo_ritstapp.png": 6425,
	"./logo_ritstapp_and_slogan.png": 5259,
	"./logo_smd.png": 6920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;